<template>
  <div>
    <v-card class="mx-auto" flat >
      <v-card-title class="d-flex justify-end pr-1">
        <v-menu v-if="isEditMode()" bottom left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn x-small text v-bind="attrs" v-on="on" class="">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list flat>
              <v-list-item @click="onEdit()">
                <v-icon class="mr-2">mdi-pencil</v-icon>
                <v-list-item-content>Edit</v-list-item-content>
              </v-list-item>
              <v-list-item @click="onDelete()">
                <v-icon class="mr-2">mdi-delete</v-icon>
                <v-list-item-content>Delete</v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>   
      </v-card-title>
      <v-card-text>
        <v-col col="12" v-if="isViewOnlyMode()">
          <div v-for="(item, i) in visibleFormData" :key="i">
            <v-row class="text-left">
              <v-col tag="strong" cols="12" v-if="$vuetify.breakpoint.mobile">{{ item.label }}</v-col>
              <v-col class="text-right mb-2" tag="strong" md="4" v-else>{{ item.label }}</v-col>
              <v-col cols="12" md="7">{{ item.text && item.value ? item.value[item.text] : item.value }}</v-col>
            </v-row>
          </div>
        </v-col>
        <v-col v-else col="12">
          <v-col v-for="(item, i) in visibleFormData" :key="i">
            <v-text-field
              v-model="item.value"
              v-if="item.type === 'text'"
              :label="item.label"
              return-object
              autocomplete="off"
              :disabled="isDisabledField(item)"
              :maxlength="maxLength(item)"              
            >
            </v-text-field>
            <v-checkbox
              v-model="item.value"
              v-if="item.type === 'boolean'"
              :label="item.label"
              :disabled="isDisabledField(item)"
            ></v-checkbox>            
            <v-select
              v-model="item.value"
              v-if="item.type === 'select'"
              :label="item.label"
              autocomplete="off"
              :item-text="item.text ? item.text : undefined"
              return-object
              :items="item.values(getValue())"
              :disabled="isDisabledField(item)"
            ></v-select>
          </v-col>
        </v-col>
      </v-card-text>
      <v-card-actions>
        <v-btn color="secondary" v-if="isEditable()" @click="onSave()">Save</v-btn>
        <v-btn v-if="isEditable() && isEditMode()" @click="onCancel()">Cancel</v-btn>
        <v-btn
          color="secondary"
          class="ml-2"
          v-for="(btn, i) in showableCustomButton"
          :key="i"
          @click="btn.callback(formDataModel)"
        >
          {{ btn.label }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
const VIEW = "view";
const EDIT = "edit";
const VIEW_EDIT = "viewEdit";
const NEW = "new";
const ALLOWED_MODES = [NEW, VIEW, EDIT, VIEW_EDIT];

export default {
  name: "EntryForm",
  props: {
    model: {
      type: Array,
      default: () => [],
    },
    data: {
      type: Object,
      default: () => ({}),
    },
    mode: {
      type: String,
      default: "new",
    },
    customButton: {
      type: Array,
      default: () => [],
    },
  },
  created() {
    if (ALLOWED_MODES.indexOf(this.mode) === -1) {
      throw new Error("IllegalArgument");
    }
    this.formData = this.data;
  },
  data: () => ({
    editable: false,
    formData: {}
  }),
  computed: {
    formDataModel() {
      const df = this.model.map((item) => {
        item["value"] = this.getItemData(item);
        return item;
      });
      return df;
    },
    visibleFormData() {
      return this.formDataModel.filter(
        (item) => item.display === undefined || item.display
      );
    },
    showableCustomButton() {
      return this.customButton.filter((btn) => btn.mode === this.mode);
    },
  },
  methods: {
    isViewOnlyMode() {
      return (
        this.mode === VIEW ||
        (this.mode === VIEW_EDIT && !this.editable)
      );
    },
    isEditMode() {
      return this.mode === EDIT || this.mode === VIEW_EDIT;
    },
    isAddMode() {
      return this.mode === NEW;
    },
    showEdit() {
      return this.mode === VIEW_EDIT && !this.editable;
    },
    isEditable() {
      return (
        this.mode === NEW ||
        (this.mode === VIEW_EDIT && this.editable)
      );
    },
    resetFormData() {
      this.formDataModel.forEach((item) => {
        item.value = this.getItemData(item);
      });
    },
    isImmutable(item) {
      return item.immutable !== undefined && item.immutable;
    },
    isComputed(item) {
      return item.computed !== undefined && item.computed;
    },
    isDisabledField(item) {
      return (!this.isAddMode() && this.isImmutable(item)) || this.isComputed(item);
    },
    maxLength(item) {
      if (item.maxLength) {
        return parseInt(item.maxLength);
      }
      return 10000;
    },
    getItemData(model) {
      const object = this.formData;
      const valueAttr = model.valueAttr;
      return object[valueAttr];
    },
    getValue() {
      const formValue = {};
      this.formDataModel.forEach((item) => {
        formValue[item.valueAttr] = item.value;
      });
      return formValue;
    },
    onEdit() {
      this.editable = true;
    },
    onDelete() {
      this.$emit("onDelete", this.getValue());
    },
    onSave() {
      this.$emit("onSave", this.getValue());
    },
    onCancel() {
      if (this.isEditMode()) {
        this.editable = false;
      }
      this.resetFormData();
    }
  },
};
</script>

<style lang="scss" scoped>
</style>